import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1b342c21&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b342c21')) {
      api.createRecord('1b342c21', component.options)
    } else {
      api.reload('1b342c21', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1b342c21&", function () {
      api.rerender('1b342c21', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/tx/index.vue"
export default component.exports